import SovosCustomThemeProvider from './CustomThemeContext';
export { ACTIONS, useCustomTheme, useDispatchCustomTheme } from './CustomThemeContext';
export default SovosCustomThemeProvider;